export default function ReversiIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <path d="M32 8v48M8 32h48" stroke="#3B434F" strokeWidth="4" strokeLinecap="round" />
      <circle cx="20" cy="20" r="10" fill="#2F8BFF" />
      <circle cx="44" cy="44" r="10" fill="#2F8BFF" />
      <circle cx="44" cy="20" r="10" fill="#FF8A1F" />
      <circle cx="20" cy="44" r="10" fill="#FF8A1F" />
      <path d="M38 14a9 9 0 0 1 12 0" stroke="#E7ECF3" strokeWidth="3" fill="none" strokeLinecap="round" />
    </svg>
  );
}
